import { fetcher } from '@insta-club/api';
import { Toman } from '@insta-club/components/icons';
import { Plan } from '@insta-club/models';
import { t } from '@insta-club/translations';
import { BottomSheet, Button } from '@insta-club/ui';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { separator } from 'src/libs/utilities/number';
import PlanItem from './plan-item';

interface Porps {
    name: string;
    plans: Plan[];
    popular: boolean;
    description: string;
    plan: Plan | null;
}

const BuyBottomSheet: React.FC<Porps> = ({ name, description, popular, plan, plans }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const router = useRouter();

    const renderBuy = () => {
        if (!plan) return null;
        return (
            <div className='flex flex-col gap-5'>
                <div className='flex flex-wrap items-center gap-1 text-sm font-semibold text-nowrap text-gray-600'>
                    <span>
                        {t('buy_subscription', name)} {plan.name}
                    </span>
                    <div className='flex items-center gap-0.5'>
                        {t('with_price', separator(plan.amount).toString())}
                        <Toman className='relative bottom-0.5 text-gray-600' />
                    </div>
                </div>
                <p className='text-sm leading-relaxed font-normal text-gray-500'>{description}</p>
                <Button loading={loading} onClick={createInvoices(plan.id)} size='lg' fullWidth>
                    {t('purchase_and_activation')}
                </Button>
            </div>
        );
    };

    const RenderSelectPlan = () => {
        const [selectedPlan, setSelectedPlan] = useState(plans[0]);
        return (
            <div className='flex flex-col gap-5'>
                <div className='flex flex-col gap-3'>
                    {plans.map((plan) => {
                        return (
                            <PlanItem
                                plan={plan}
                                key={`plan-${plan.id}`}
                                onSelect={setSelectedPlan}
                                selected={plan.id == selectedPlan.id}
                            />
                        );
                    })}
                </div>
                <Button loading={loading} onClick={createInvoices(selectedPlan.id)} size='lg' fullWidth>
                    {t('purchase_and_activation')}
                </Button>
            </div>
        );
    };

    const createInvoices = (plan_id: number) => async () => {
        try {
            setLoading(true);
            const res = await fetcher('/invoices', 'dashboard', 'POST', {
                body: {
                    plan_id
                }
            });
            router.push(`/payment/checkout/${res.id}`);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const isPlanFull = plan && plan.total_capacity > 0 && plan.remaining_capacity <= 0;

    // اگر پلن پر شده یا پلنی انتخاب نشده، چیزی نمایش نده
    if (isPlanFull || !plan) return null;

    return (
        <Button loading={loading} onClick={createInvoices(plan.id)} size='sm' fullWidth>
            {t('purchase_and_activation')}
        </Button>
    );

    return (
        <BottomSheet
            title={t('buy_subscription', name)}
            trigger={
                <Button loading={loading} onClick={createInvoices(plan?.id ?? 0)} size='sm' fullWidth>
                    {t('purchase_and_activation')}
                </Button>
            }
        >
            {popular ? renderBuy() : <RenderSelectPlan />}
        </BottomSheet>
    );
};

export default BuyBottomSheet;

